import React from 'react';
import { useLanguage } from '../../i18n';
import './faq.css';

const FAQ = () => {
    const { t } = useLanguage();
    const questions = t('faq.questions');

    return (
        <div className="faq-container">
            <h1>{t('faq.title')}</h1>
            <div className="faq-list">
                {questions.map((faq, index) => (
                    <div key={index} className="faq-item">
                        <h3 style={{ color: '#073C5C' }}>{faq.question}</h3>
                        <p>{faq.answer}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;
